import { useTheme } from "hooks/useTheme";
import { useRef, useState, useEffect } from "react";
import { FaPause, FaPlay } from "react-icons/fa";
import { isColorDark } from "utils/utilityFunctions";

export default function MinimalAudioPlayer({ src }: any) {
  const audioRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(null); // Set initial value to null

  const updateTime = () => {
    const audio = audioRef.current;

    setCurrentTime(audio.currentTime);
  };
  useEffect(() => {
    const audio = audioRef.current;

    const handleLoadedMetadata = () => {
      // Sometimes duration is Infinity initially, so seek to force a calculation
      if (audio.duration === Infinity) {
        audio.currentTime = 1e101;
        audio.ontimeupdate = () => {
          audio.ontimeupdate = null; // cleanup
          setDuration(audio.duration);
          audio.currentTime = 0; // Reset after seeking
        };
      } else {
        setDuration(audio.duration);
      }
    };

    audio.addEventListener("loadedmetadata", handleLoadedMetadata);
    audio.addEventListener("timeupdate", updateTime);

    return () => {
      audio.removeEventListener("loadedmetadata", handleLoadedMetadata);
      audio.removeEventListener("timeupdate", updateTime);
    };
  }, []);

  const togglePlay = () => {
    const audio = audioRef.current;
    if (isPlaying) {
      audio.pause();
    } else {
      audio.play();
    }
    setIsPlaying(!isPlaying);
  };

  const handleSeek = (e: any) => {
    const newTime = parseFloat(e.target.value);
    audioRef.current.currentTime = newTime;
    setCurrentTime(newTime);
  };

  const formatTime = (time: any) => {
    if (isNaN(time) || time === 0) return "0:00";
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60)
      .toString()
      .padStart(2, "0");
    return `${minutes}:${seconds}`;
  };

  const theme = useTheme();
  return (
    <div>
      <audio ref={audioRef} src={src} preload="metadata" />
      <div
        style={{
          color: isColorDark(theme.main) ? "white" : "black",
          fontSize: 14,
        }}
      >
        {formatTime(currentTime)} / {formatTime(duration)}
      </div>
      <div className="controls">
        <input
          type="range"
          min="0"
          max={duration || 0} // Wait until the duration is set
          step="0.1"
          value={currentTime}
          onChange={handleSeek}
        />
      </div>
      <button
        onClick={togglePlay}
        style={{
          fontSize: "20px",
          marginTop: "10px",

          color: isColorDark(theme.main) ? "white" : "black",
        }}
      >
        {isPlaying ? <FaPause /> : <FaPlay />}
      </button>

      <style>{`
        .player {
          background: #f9f9f9;
          border: 1px solid #ddd;
          border-radius: 10px;
          width: 100%;
          max-width: 400px;
          font-family: sans-serif;
        }
        .controls {
          display: flex;
          align-items: center;
          gap: 0.75rem;
          margin-top: 0.5rem;
        }
        button {
          background: none;
          border: none;
          font-weight: bold;
          cursor: pointer;
          padding: 0.25rem 0.5rem;
        }
        input[type="range"] {
          flex: 1;
          appearance: none;
          height: 4px;
          border-radius: 2px;
          background: #ccc;
          outline: none;
        }
        input[type="range"]::-webkit-slider-thumb {
          appearance: none;
          width: 10px;
          height: 10px;
          background: #333;
          border-radius: 50%;
          cursor: pointer;
        }
 
      `}</style>
    </div>
  );
}
